<style>
@import '../../assets/css/transaction.css';
</style>

<template>
    <div class="main-panel">
        <div class="main-content">
            <b-card :header="$t('button.search')" header-tag="header" class="mb-3">
                <form @submit.prevent="initialize" :submit="initialize">
                    <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label">{{$t('admin.table_username')}}</template>
                        <el-input v-model="ajaxSearch.master_id" clearable></el-input>
                    </b-form-group>
                    <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label">{{$t('admin.table_code')}}</template>
                        <el-input v-model="ajaxSearch.code" clearable></el-input>
                    </b-form-group>
                    <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label">{{$t('admin.table_from_user')}}</template>
                        <el-input v-model="ajaxSearch.from_master_id" clearable></el-input>
                    </b-form-group>
                     <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label">{{$t('admin.table_to_user')}}</template>
                        <el-input v-model="ajaxSearch.to_master_id" clearable></el-input>
                    </b-form-group>
                    <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label">{{$t('admin.table_transaction_type')}}</template>
                        <b-form-select v-model="ajaxSearch.transaction_type">
                            <option value="">-</option>
                            <option v-for="(list,index) in ajaxToolList.transactionStatusList" :key="index" :value='list.name'>{{list.name}}</option>
                        </b-form-select>
                    </b-form-group>
                    <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label"></template>
                        <b-button variant="primary" type="submit">{{$t('button.search')}}</b-button>
                    </b-form-group>
                </form>
            </b-card>
            <b-card :header="$t($route.name)">
                <el-table class="custom-table" :data="ajaxTable" @expand-change="expandChange" @row-click="expandRow" ref="tableTest" border>
                    <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" :min-width="title.width">
                        <template slot="header">
                            <p>{{title.label}}</p>
                            <b-form-input :placeholder="title.label" @keyup.enter="initialize()" v-model="ajaxSearch[title.prop]"></b-form-input>
                        </template>
                    </el-table-column>
                    <el-table-column type="expand">
                        <b-button variant="info" size="lg" @click="infoGratis()">{{$t('admin.table_check_details')}}</b-button>
                    </el-table-column>
                </el-table>
                <b-row class="mt-3">
                    <b-col sm="12" md="3" class="pr-0">
                        <span class="float-left">{{$t('admin.table_show_result',{result:ajaxTool.total_number})}}</span>
                    </b-col>
                    <b-col sm="12" md="9" class="pl-0">
                        <el-pagination class="text-right" layout="sizes,prev, pager, next" @size-change="paginationSizeChange" @current-change="paginationCurrentChange" :current-page.sync="ajaxTool.current_pagination" :total="ajaxTool.total_number" :hide-on-single-page="1" :page-sizes="[10, 30, 50, 100]" :page-size="10" background></el-pagination>
                    </b-col>
                </b-row>
            </b-card>
            <b-modal id="infoGratis" :title="$t('admin.table_check_details')" hide-footer size="xl">
                <b-row class="form-label">
                    <b-col cols="12" lg="6">
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_id')}}</template>
                            <label>{{ajaxInfo.id}}</label>
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_date')}}</template>
                            <label>{{ajaxInfo.created_at}}</label>
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_code')}}</template>
                            <label>{{ajaxInfo.code}}</label>                                                        
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_username')}}</template>
                            <label>{{ajaxInfo.master_id}}</label>                                                        
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_from_user')}}</template>
                            <label>{{ajaxInfo.from_master_login}}</label>                                                        
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_to_user')}}</template>
                            <label>{{ajaxInfo.to_master_login}}</label>                                                        
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_transaction_type')}}</template>
                            <label>{{ajaxInfo.transaction_type}}</label>                                                        
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_amount')}}</template>
                            <label>{{ajaxInfo.total_amount}}</label>                                                        
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" lg="6">
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_order_id')}}</template>
                            <label>{{ajaxInfo.order_id}}</label>                                                        
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_refer_id')}}</template>
                            <label>{{ajaxInfo.refer_id}}</label>                                                        
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_remark')}}</template>
                            <label style="word-break: break-all;">{{ajaxInfo.remark}}</label>                                                        
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_from_master_id')}}</template>
                            <label>{{ajaxInfo.from_master_id}}</label>                                                        
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_to_master_id')}}</template>
                            <label>{{ajaxInfo.to_master_id}}</label>                                                        
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-modal>
        </div>
    </div>
</template>

<script>
import {gratisAjaxTable,gratisInfo} from '@/system/model/coin_report'
import {removeTokenByName} from '@/system/store/cookie';
import {getSessionStorage,setSessionStorage } from '@/system/store/sessionstorage';
import {setLocalStorage, getLocalStorage} from '@/system/store/localstorage';

export default {
    inject:['preloader'],
    data(){
        return{   
            ajaxLoad:false,
            ajaxTable:[],
            ajaxTool:[],
            ajaxToolList:[],
            ajaxSearch:{limit:'',pagination:'',id:'',created_at:'',code:'',master_id:'',from_master_id:'',to_master_id:'',transaction_type:'',total_amount:''},
            ajaxRow:'',
            ajaxEdit:[],
            ajaxExportStart:'',
            ajaxExportEnd:'',
            statusList:[],
            showEdit: false,
            pageLimit:10,
            ajaxInfo:'',
            permission:{
            },
            permissionList:[],
            titles:[{
                prop: "id",
                label: this.$t('admin.table_id'),
                width:'118'
            },{
                prop: "created_at",
                label: this.$t('admin.table_date'),
                width:'234'
            },{
                prop: "code",
                label: this.$t('admin.table_code'),
                width:'234'
            },{
                prop: "master_id",
                label: this.$t('admin.table_username'),
                width:'234'
            },{
                prop: "from_master_id",
                label: this.$t('admin.table_from_user'),
                width:'234'
            },{
                prop: "to_master_id",
                label: this.$t('admin.table_to_user'),
                width:'234'
            },{
                prop: "transaction_type",
                label: this.$t('admin.table_transaction_type'),
                width:'150'
            },{
                prop: "total_amount",
                label: this.$t('admin.table_amount'),
                width:'150'
            }],        
        }
    },methods:{
        initialize(){
            var self = this;
            var result = gratisAjaxTable(this.ajaxSearch.limit,this.ajaxSearch.pagination,this.ajaxSearch.id,this.ajaxSearch.created_at,this.ajaxSearch.code,this.ajaxSearch.master_id,this.ajaxSearch.from_master_id,this.ajaxSearch.to_master_id,this.ajaxSearch.transaction_type,this.ajaxSearch.total_amount);
            this.preloader(true);
            result.then(function(value){
                if(value.valid){
                    self.preloader(false);
                    self.ajaxLoad = true;
                    self.ajaxTable = value.data.datatable.data;
                    self.ajaxTool = value.data.datatable;
                    self.csrfName = value.data.csrf_list.csrf_name;
                    self.csrfValue = value.data.csrf_list.csrf_value;
                    self.csrfNameKey = value.data.csrf_list.csrf_name_key;
                    self.csrfValueKey = value.data.csrf_list.csrf_value_key;
                    self.permissionList = JSON.parse(getLocalStorage('permission_list'));
                    
                }else{
                    self.preloader(false);
                    self.$swal.fire({
                        type: 'error',
                        html: self.$t('login.error_relogin'),
                        onClose: () => {
                            removeTokenByName('auth_sign_token');
                            self.$router.push('/');
                        }
                    });		
                }
            });
        },getToolList(){
            var self = this;
            var result = this.$general.getToolList();
            result.then(function(value){
                self.ajaxToolList = value.data;
            });
        },infoGratis(){
            var self = this;
            var result = gratisInfo(this.ajaxRow);
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                self.$bvModal.show('infoGratis');
                if(value.valid){
                    self.ajaxInfo = value.data.this_detail;
                }
            });
        },expandRow(row){
            this.$refs.tableTest.toggleRowExpansion(row);
            this.ajaxRow = row.id;
            this.showEdit = false;
        },expandChange(row,expandedRows){
            if(expandedRows.length>1){
                expandedRows.shift()
            }
        },paginationSizeChange(limit){
            this.ajaxSearch.limit = limit;
            this.initialize();
        },paginationCurrentChange(pagination){
            this.ajaxSearch.pagination = pagination;
            this.initialize();
        }
    },created(){
        this.preloader(false);
        this.initialize();
        this.getToolList();
    }
}
</script>
